import { useMutation, useQueryClient } from "@tanstack/react-query";
import { submitDeposit } from "@/api/v1-jwt/mrdc/mrdc";

export const useSubmitMRDC = () => {
  const query = useQueryClient();

  return useMutation({
    mutationFn: submitDeposit,
    onSettled: () => {
      query.invalidateQueries(["mrdc"]);
    },
  });
};
